{
  "actions": {
    "back": "Back",
    "close": "Close",
    "minimize": "Minimize",
    "maximize": "Maximize",
    "restore": "Restore"
  },
  "home": {
    "title": "Home",
    "role": "Product Designer & Developer",
    "pitch": "I tackle what most people avoid: complexity. Where UX, engineering, and business blur together, I find patterns, remove noise, and make it logical again.",
    "available": "Available for projects and permanent positions",
    "cta_work": "View my work",
    "cta_contact": "Get in touch"
  },
  "work": {
    "title": "Work",
    "heading": "Selected Work",
    "filters": {
      "all": "All",
      "apps": "Applications",
      "video": "AI Video",
      "design": "Design"
    },
    "back": "Back",
    "role": "Role",
    "tech": "Technology",
    "results": "Results",
    "view_case": "View case study",
    "cta_title": "Ready to start your project?",
    "cta_button": "Let's talk"
  },
  "about": {
    "title": "About",
    "heading": "The full picture",
    "intro": "I'm essentially a translator. Turning vague ideas and disconnected systems into something that works, scales, and feels great for the user. I'm at my best when things seem 'too complex'.",
    "approach_title": "How I work",
    "approach": "My workflow revolves around one thing: back to the essence. I combine things that usually stand alone, turn abstract ideas into concrete prototypes quickly, and always think ahead. Anything unnecessary gets removed.",
    "capabilities_title": "My path & focus",
    "capabilities": {
      "ux": "UX as a foundation (since 2018) — Starting with the user. How do people think? Where do they drop off? What feels logical?",
      "tech": "Technical insight — Frontend development to understand exactly how things are built, ensuring design and engineering perfectly align.",
      "ai": "AI as an accelerator — Not as a gimmick, but to make workflows smarter. Prompt engineering, AI integrations, and combining tools.",
      "now": "Versatile by nature — From websites and apps to wireframes, mockups, flyers, and dashboards. I do thorough UX research, figure everything out, and deliver products that truly resonate with the end user.",
      "drive": "What drives me — I test a lot, build a lot, and try things outside the lines. And yes, coffee helps too."
    }
  },
  "resume": {
    "title": "Resume",
    "download": "Download Resume (.pdf)",
    "experience": "Experience",
    "education": "Education",
    "skills": "Skills",
    "freelance_role": "Freelance Product Designer & Developer",
    "freelance_company": "MvlCreative",
    "freelance_period": "2021 — Present",
    "freelance_description": "Designing and building scalable digital products. From UX strategy and design systems to frontend development and AI integrations. I bridge the gap between design, engineering, and business.",
    "webheld_role": "Web Developer",
    "webheld_company": "Webheld — Baarn",
    "webheld_period": "2020 — 2021",
    "webheld_description": "Built and optimized websites and webshops in WordPress and Magento. From custom development and SEO to wireframing and visual design.",
    "aim_role": "Web Developer",
    "aim_company": "Aim — Badhoevedorp",
    "aim_period": "2020",
    "aim_description": "Built websites from design to delivery. Maintained and iterated on WordPress environments.",
    "tweak_role": "Service Desk",
    "tweak_company": "Tweak — Almere",
    "tweak_period": "2019 — 2020",
    "tweak_description": "First point of contact for technical customer inquiries. Problem analysis, troubleshooting, and administrative handling.",
    "more_coming": "More experience will be added soon."
  },
  "contact": {
    "title": "Contact",
    "heading": "Get in touch",
    "phone_label": "Phone",
    "location": "Almere, Netherlands",
    "location_label": "Location",
    "availability": "Available across the Netherlands and remote",
    "status": "Available for projects and permanent positions",
    "cta_call": "Schedule a video call",
    "social_label": "Social",
    "status_label": "Status"
  },
  "boot": {
    "loading": "Loading creativity...",
    "design_systems": "Initializing design systems...",
    "connecting_ai": "Connecting AI...",
    "ready": "Ready."
  },
  "command": {
    "placeholder": "Search or navigate...",
    "projects": "Projects",
    "navigation": "Navigation",
    "settings": "Settings"
  }
}